// 酪蛋白产业链数字化 · 下级页面（内容暂为空白占位，后续补充）
// 2221 版（7680×2160）：字号/尺寸按 2221 比例放大
<template>
  <div class="subpage chain-sub">
    <div class="cs-body">
      <div class="cs-badge">{{ title }}</div>
      <div class="cs-placeholder">
        <div class="cs-ring"></div>
        <p class="cs-tip">内容建设中，敬请期待</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'chainSub',
  computed: {
    title() {
      const raw = this.$route.params.name || '';
      let t = raw;
      try { t = decodeURIComponent(raw); } catch (e) { /* 保持原值 */ }
      return t;
    },
  },
};
</script>

<style lang="less" scoped>
.chain-sub {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.cs-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 120px;
}

.cs-badge {
  color: #fff;
  font-size: 112px;
  font-weight: 700;
  letter-spacing: 16px;
  background: linear-gradient(90deg, rgba(0, 229, 255, 0), rgba(0, 229, 255, 0.3), rgba(0, 229, 255, 0));
  padding: 20px 160px;
}

.cs-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 80px;
}

.cs-ring {
  width: 280px;
  height: 280px;
  border-radius: 50%;
  border: 12px solid rgba(0, 229, 255, 0.18);
  border-top-color: #00E5FF;
  animation: cs-spin 1.6s linear infinite;
}

@keyframes cs-spin {
  to { transform: rotate(360deg); }
}

.cs-tip {
  color: rgba(255, 255, 255, 0.75);
  font-size: 68px;
  letter-spacing: 12px;
}
</style>
